// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3640":"c3207b43","6138":"2c46f063"}[chunkId] + ".chunk.css";
};